export function SocialReferralSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/social-referal.svg'"></ng-include>`
    }
}